module.exports = __webpack_public_path__ + "img/pwa_food_top3.d2b93338.png";